export class Student {
  constructor({
    id,
    dateIn,
    dateOut,
    minutesLate,
    attendanceType,
    createdAt,
    level,
    gradeGroup,
    firstName,
    lastName,
    personId,
    notes,
  } = {}) {
    this.id = id
    this.dateIn = dateIn
    this.dateOut = dateOut
    this.minutesLate = minutesLate
    this.attendanceType = attendanceType
    this.createdAt = createdAt
    this.level = level
    this.gradeGroup = gradeGroup
    this.firstName = firstName
    this.lastName = lastName
    this.personId = personId
    this.notes = notes
  }
}
